<p-toast [style]="{ marginTop: '80px' }"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<div class="row m-0">
  <div class="d-block text-end justify-content-between align-items-center col-lg-12 p-0">
    <span class="d-flex justify-content-between align-items-center topbx">
      <!--add new-->
      <div class="topbx-select">
        <!--<div class="mailcheck">
        <p-checkbox [(ngModel)]="selectAllCheckbox" [binary]="true" (onChange)="selectAllCheckboxChanged()"></p-checkbox>
        <span *ngIf="selectedMails.length>0"> &nbsp;&nbsp;  <b>{{selectedMails.length}} Mails selected</b></span>
      </div>-->
      @if (selectedMails.length>0) {
        <button pButton pRipple class="p-button"
          style="padding: 0.643rem 0.75rem !important;  margin-right:10px;" (click)="archiveSelected()">Archive
        </button>
      }
      <!--<p-selectButton [options]="mailBoxes" [(ngModel)]="selectedmailbox" (onChange)="loadMailBox($event)" optionLabel="label" optionValue="value">
      <ng-template let-item>
        <i [class]="item.icon"></i> &nbsp;&nbsp; {{item.label}}
      </ng-template>
    </p-selectButton>-->
    <!--<div class="pt-3 searchbx">Select Account:<p-multiSelect #aa [options]="inboxNames" [displaySelectedLabel]="true" display="chip" [(ngModel)]="mailBoxIds"
  optionLabel="name" optionValue="imapConfigurationId" appendTo="body" (onChange)="pt.filter($event.value, 'ImapConfigurationVO.imapConfigurationId', 'in')"></p-multiSelect></div>-->
  @if (false) {
    <div class="d-flex emailbx gap-3">
      <div class="col-lg-6 d-flex align-items-center gap-2">
        <label>Email:</label>
        <input pInputText type="text" (input)="pt.filter($event.target.value, 'msgRecipientVOList.email', 'in')">
      </div>
      <div class="col-lg-6 d-flex align-items-center gap-2">
        <label>Mobile:</label>
        <input pInputText type="text"
          (input)="pt.filter($event.target.value, 'msgRecipientVOList.mobileNum', 'in')">
      </div>
    </div>
  }

</div>
<div class="ctmbutton">
  <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;  margin-right:10px;"
  (click)="onOpenFormAddMailAndSMS()"> Compose +</button>

  <!--      based on Email text is left blank or SMS text left blank we would be sending the EMail or Text

  So no need to -->
  <!--<button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;  margin-right:10px;"
(click)="onOpenFormAdd()"> Mail +</button>

<button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;  margin-right:10px;"
(click)="onOpenFormAddForSMS()">SMS +</button>-->
<!--refresh mails-->
<button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
(click)="refreshMails()">Refresh</button>
</div>
</span>
</div>
</div>
<div class="row m-0 g-communication">
  <div class="col-lg-4 leftsidebar pl-0">
    <p-treeTable class="kbmadmintable" #pt [value]="inboxs" [paginator]="true" dataKey="msgId" selectionMode="single" [loading]="loading"
      [columns]="columns" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="msgId"
      (onNodeExpand)="onNodeExpand($event)" [rows]="25" [rowsPerPageOptions]="[25, 100, 200]"
      showCurrentPageReport="true" styleClass="p-datatable-striped"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
      [totalRecords]="recordTotal" [tableStyle]="" [resizableColumns]="true" [autoLayout]="true" [scrollable]="true"
      [ngStyle]="{ width: '100%' }" [(contextMenuSelection)]="selectedNode" [contextMenu]="gf">
      <!-- Table Headers -->
      <ng-template pTemplate="header">
        <tr>
          <th>S</th>
          <th>Date</th>
          <th>From</th>
          <th>Subject</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
        <tr [ttRow]="rowNode" [ttContextMenuRow]="rowNode" (click)="openSelectedMail(rowData)">
          <!-- <td [ngStyle]="{'background-color': rowData.ischild ? '#fffff1' : null}"
          [ngClass]="{'child-padding': rowData.ischild}" class="d-none"> -->

          <!-- <div class="d-flex databx align-items-center"> -->
          <!--<div>
          <p-checkbox [(ngModel)]="rowData.checkboxFlag" [binary]="true"  (onChange)="mailSelectionChanged(rowData)"></p-checkbox>
        </div>-->
        <!-- <span *ngIf="rowData?.imapConfigurationAPI?.name==='TWILIO DO NOT CHANGE'" class="mailnameauto"
        title="System Generated Mail">
        A
      </span> -->
      <!-- <div class="mailname">
      <span title="{{rowData?.imapConfigurationAPI?.name}}">{{rowData?.nameInitial}}</span>
    </div> -->

    <!-- <div class="right-content"> -->
    <!-- <p class="d-flex justify-content-between m-0"><b>{{ rowData['subject'] }}</b> <span class="dateinfo"
    style="margin-left: auto;margin-right: 0px"><small>{{ rowData['dateCreation']|date }}</small></span>
  </p> -->
  <!-- <p class="d-flex justify-content-between m-0"><b>{{ rowData['mobileText'] }}</b></p> -->
  <!--<div class="iconlist">
  <img src="../../../../assets/img/mail.png" alt="New Message">
  <img src="../../../../assets/img/unread.png" alt="UnRead">
  <img src="../../../../assets/img/receive.png" alt="Receive">
</div>-->
<!-- <div class="mailinfo d-flex align-items-center gap-3 py-2">
<span>{{rowData?.reservationAPI?.shortTermRental?.propertyCode}}</span>
<span class="link" *ngIf="rowData?.reservationAPI?.guestProfile?.lastName">
{{rowData?.reservationAPI?.guestProfile?.lastName}}</span>
</div> -->
<!-- <div class="m-0 pt-1 sendemail">
<span *ngIf="rowData?.emailHtml"><i class="pi pi-envelope ng-star-inserted"></i>
<span><small> {{ rowData?.senderEmail }} to
{{rowData?.msgRecipientAPIList[0]?.email}}</small></span>
</span>
<span *ngIf="rowData?.mobileText"><i class="pi pi-mobile ng-star-inserted"></i>
<small> {{ rowData['senderCountryCode'] }}{{ rowData['senderMobileNum'] }}</small>
</span>

</div> -->
<!-- </div> -->
<!-- <p-treeTableToggler [rowNode]="rowNode" *ngIf="getNumberOfChildMsg(rowData)>0"></p-treeTableToggler> -->
<!-- <span *ngIf="getNumberOfChildMsg(rowData)>0">
<div class="number">
  <span class="numbertxt"
  *ngIf="getNumberOfChildMsg(rowData) > 0">{{getNumberOfChildMsg(rowData)}}</span>
</div>
</span> -->
<!-- </div> -->
<!-- </td> -->
<td>
  @if (rowData?.imapConfigurationAPI?.name==='TWILIO DO NOT CHANGE' && rowData?.topicPurpose!=10000) {
    <span class="mailnameauto"
      title="System Generated Mail">
      A
    </span>
  }
</td>
<td>
  <span>{{ rowData['dateCreation']|date }}</span>
</td>
<td>
  <span>{{limitText(rowData?.senderEmail,15) }}</span>
  @if (rowData?.mobileText) {
    <span>{{limitText(rowData?.senderMobile,15) }}</span>
  }
</td>
<td>
  <span>{{ limitText(rowData['subject'], 60) }}</span>
  @if (rowData?.mobileText) {
    <span>{{ limitText(rowData?.mobileText, 60) }}</span>
  }
</td>
</tr>
</ng-template>
</p-treeTable>
<p-contextMenu #gf appendTo="body" [model]="items"></p-contextMenu>
</div>
<div class="col-lg-8 mailbxinfo">
  @if (selectedMailEntry) {
    <mat-tab-group class="tabs-group">
      @if (selectedMailEntry.emailHtml ||  selectedMailEntry.emailText) {
        <mat-tab label="Mail">
          <app-inbox [inbox]="selectedMailEntry" (doUpdate)="msgSent($event)" [showClose]="false"></app-inbox>
        </mat-tab>
      }
      @if (selectedMailEntry.mobileText) {
        <mat-tab label="SMS">
          <app-inbox-sms [inbox]="selectedMailEntry" [showClose]="false" (doAdd)="msgSent($event)" ></app-inbox-sms>
        </mat-tab>
      }
    </mat-tab-group>
  }
</div>
</div>
